import axios from "axios";
import { toast } from "react-toastify";
import server from "../../../../Components/server";

export default async function handleImageUpload({
  images,
  setImages,
  onError,
}) {
  const length = images?.filter((item) => item != null)?.length;
  let compiledUrl = "";

  //   console.log("handleImageUpload");

  for (let i = 0; i < length; i++) {
    const file = images[i];

    if (!file) continue;
    // console.log("handleImageUpload file present");

    if (typeof file === "string") {
      if (i === length - 1) {
        compiledUrl += file;
      } else {
        compiledUrl += file + ", ";
      }

      console.log(compiledUrl);
      continue;
    }

    const fileName = file.name;

    // console.log("handleImageUpload", fileName);

    try {
      // Get presigned URL for upload
      const response = await axios.get(`${server}/get-upload-url`, {
        params: { fileName, fileType: file.type },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      const uploadURL = response.data.uploadURL;
      const downloadURL = response.data.downloadURL
        ? response.data.downloadURL.split("?")[0]
        : "";

      if (!uploadURL || !downloadURL) {
        throw new Error("Invalid presigned URL received from server");
      }

      // Upload the image to S3 using presigned URL
      await axios.put(uploadURL, file, {
        headers: {
          "Content-Type": file.type,
        },
      });

      if (i === length - 1) {
        compiledUrl += downloadURL;
      } else {
        compiledUrl += downloadURL + ", ";
      }

      const newImages = [...images];
      newImages[i] = downloadURL;
      if (setImages) setImages(newImages);
    } catch (error) {
      console.error("Error uploading image:", error);
      const errorDetail =
        error?.response?.data?.details ||
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Image upload failed";
      toast.error(`Image upload failed: ${errorDetail}`);
      if (onError) onError(error);
      return null;
    }
  }

  return compiledUrl.trim() || null;
}
